module.exports = __webpack_public_path__ + "img/banner_6.b608d07e.jpg";